export default "<div class=\"sidebar-container\">\n  <!-- Sidebar filter controls go here -->\n</div>\n"